export const locale = {
    lang: "en-US",
    data: {
        PRIVACY_POLICE: {
            TITLE: "Privacy Police",
            DEFAULT: "Error retrieving privacy police.",
            SUBMIT_ERROR: "Error on request privacy police.",
            BUTTON_LABEL: "Close"
        }
    }
};
